// extracted by mini-css-extract-plugin
export default {"page":"MGPage_page__GiSNh","mobileViewport":"MGPage_mobileViewport__uOZ-m","body":"MGPage_body__ji8tJ","content":"MGPage_content__G31wm"};